<div class="container">
    <div class="header">
        <div class="logo-container">
            <img src="images/opensquash/sponsors/logo-liga.png" alt="Logo Liga Squash" class="logo" style="width: 100px;">
            <img src="images/opensquash/sponsors/bolar-logo.png" alt="Logo Bolar" class="logo">
        </div>
        <div>
            <h1>IV Válida Departamental de Squash</h1>
            <p>Medellín Agosto 2025</p>
        </div>
        <div class="admin-icon" (click)="authAdmin()" *ngIf="!(esAdmin$ | async)">
            <svg fill="#FFF" width="48px" height="48px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M276.941 440.584v565.722c0 422.4 374.174 625.468 674.71 788.668l8.02 4.292 8.131-4.292c300.537-163.2 674.71-366.268 674.71-788.668V440.584l-682.84-321.657L276.94 440.584Zm682.73 1479.529c-9.262 0-18.523-2.372-26.993-6.89l-34.9-18.974C588.095 1726.08 164 1495.906 164 1006.306V404.78c0-21.91 12.65-41.788 32.414-51.162L935.727 5.42c15.134-7.228 32.866-7.228 48 0l739.313 348.2c19.765 9.374 32.414 29.252 32.414 51.162v601.525c0 489.6-424.207 719.774-733.779 887.943l-34.899 18.975c-8.47 4.517-17.731 6.889-27.105 6.889Zm467.158-547.652h-313.412l-91.595-91.482v-83.803H905.041v-116.78h-83.69l-58.503-58.504c-1.92.113-3.84.113-5.76.113-176.075 0-319.285-143.21-319.285-319.285 0-176.075 143.21-319.398 319.285-319.398 176.075 0 319.285 143.323 319.285 319.398 0 1.92 0 3.84-.113 5.647l350.57 350.682v313.412Zm-266.654-112.941h153.713v-153.713L958.462 750.155l3.953-37.27c1.017-123.897-91.595-216.621-205.327-216.621S550.744 588.988 550.744 702.72c0 113.845 92.612 206.344 206.344 206.344l47.21-5.309 63.811 63.7h149.873v116.78h116.781v149.986l25.412 25.299Zm-313.4-553.57c0 46.758-37.949 84.706-84.706 84.706-46.758 0-84.706-37.948-84.706-84.706s37.948-84.706 84.706-84.706c46.757 0 84.706 37.948 84.706 84.706"
                    fill-rule="evenodd" />
            </svg>
        </div>
        <div class="admin-icon" (click)="logout()" *ngIf="esAdmin$ | async">
            <svg width="48px" height="48px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16.5V19C15 20.1046 14.1046 21 13 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3H13C14.1046 3 15 3.89543 15 5V8.0625M11 12H21M21 12L18.5 9.5M21 12L18.5 14.5"
                    stroke="#CCC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
    </div>

    <div class="category-selector">
        <a class="category-btn" routerLink="info" routerLinkActive="active">Información General</a>
        <ng-container *ngFor="let category of categories">
            <a class="category-btn" [routerLink]="['category', category.category]"
                routerLinkActive="active">{{category.category}}</a>
        </ng-container>
    </div>

    <router-outlet />

    <app-sponsors-component></app-sponsors-component>
</div>